import { render, staticRenderFns } from "./BirSalesReportV2.vue?vue&type=template&id=133727c7&"
import script from "./BirSalesReportV2.vue?vue&type=script&lang=js&"
export * from "./BirSalesReportV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports